// extracted by mini-css-extract-plugin
export default {"footer":"ValidateTask_footer__Epw+4"};